import React, { Suspense } from "react";
import TablePagesTitle from "../../../components/table-pages-title/TablePagesTitle";
import ReportPageAction from "../page-action/ReportPageAction";
import { commonText, monthlyLending } from "../../../locales/en";

const MonthlyLendingFilter = React.lazy(() => import("./MonthlyLendingFilter"));

export default function MonthlyLending() {
  return (
    <>
      <TablePagesTitle mainTitle={monthlyLending?.mainTitle} />

      <ReportPageAction subheading={monthlyLending?.subH2} />

      <div className="row mt-4 mb-2 mx-0 " />
      <div className="col-md-12">
        <Suspense fallback={<div>{commonText.fallbackLoader}</div>}>
          <MonthlyLendingFilter />
        </Suspense>
      </div>
    </>
  );
}
